import React from 'react';
import { BookOpenIcon, ShieldCheckIcon } from 'lucide-react';
export function BenefitsSection() {
  return <section className="bg-white py-12 px-4" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-15">
          {/* Column 1: What you receive */}
          <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-16">
            <div className="flex items-center gap-3 mb-6" data-id="element-17">
              <BookOpenIcon className="w-8 h-8 text-blue-600" data-id="element-18" />
              <h3 className="text-2xl font-bold text-[#111827]" data-id="element-19">
                Qué vas a recibir:
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-20">
              {['Manual digital completo', 'Protocolos organizados por tipo de emergencia', 'Señales claras de gravedad', 'Diferencias entre perros y gatos', 'Guía rápida de consulta inmediata'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-21">
                  <div className="w-1.5 h-1.5 rounded-full bg-blue-600 mt-2.5 flex-shrink-0" data-id="element-22" />
                  <span className="text-[#4B5563] text-lg" data-id="element-23">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Column 2: What you achieve */}
          <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-24">
            <div className="flex items-center gap-3 mb-6" data-id="element-25">
              <ShieldCheckIcon className="w-8 h-8 text-green-600" data-id="element-26" />
              <h3 className="text-2xl font-bold text-[#111827]" data-id="element-27">
                Qué vas a lograr:
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-28">
              {['Actuar con calma', 'Reducir el pánico', 'Evitar errores comunes', 'Ganar minutos vitales', 'Sentirte preparado'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-29">
                  <div className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2.5 flex-shrink-0" data-id="element-30" />
                  <span className="text-[#4B5563] text-lg" data-id="element-31">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}